
export const fetchCoursesIfNeeded = (courseCode) => {
  return (dispatch, getState) => {
    if (shouldFetchCourses(getState())) {
      return dispatch(fetchCourses(courseCode))
    }
    return Promise.resolve()
  }
}

const shouldFetchCourses = state => {
  return !state.courses.data
}

export const fetchCourses = (courseCode) => {
  return dispatch => {
    dispatch(requestCourses())

    let queryParams = {}
    queryParams["spkCode"] = courseCode

    return getCoursesSummary(queryParams).then((courses = []) => {
      return dispatch(receiveCourses(courses))
    })
  }
}

export const storeCourseCode = courseCode => {
  return {
    type: 'STORE_COURSE_CODE',
    courseCode
  }
}

const requestCourses = () => {
  return {
    type: 'REQUEST_COURSES'
  }
}

export const receiveCourses = (courses = []) => {
  return {
    type: 'RECEIVE_COURSES',
    courses
  }
}
